if (!customElements.get('jn-look-studio')) {
  customElements.define('jn-look-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.editorialCaption = this.querySelector('[data-caption]').textContent;
      this.pieces = [...this.querySelectorAll('[data-piece]')];
      this.status = this.querySelector('[data-status]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-enhanced]').forEach(el => { el.hidden = false; });
      this.querySelectorAll('.jn-piece-form').forEach(form => form.addEventListener('submit', event => {
        event.preventDefault();
        if (form.reportValidity()) this.add([form.closest('[data-piece]')]);
      }, options));
      this.addEventListener('change', event => {
        const piece = event.target.closest('[data-piece]');
        if (!piece) return;
        if (event.target.matches('[data-variant]')) {
          event.target.removeAttribute('aria-invalid');
          const src = event.target.selectedOptions[0]?.dataset.image;
          const img = piece.querySelector('img');
          if (src && img) { img.removeAttribute('srcset'); img.src = src; }
        }
        this.update();
      }, options);
      this.querySelector('[data-select-all]').addEventListener('click', () => {
        this.pieces.forEach(piece => { const box=piece.querySelector('[data-include]'); if(!box.disabled) box.checked=true; });
        this.update();
      }, options);
      this.querySelector('[data-add-selected]').addEventListener('click', () => {
        const selected = this.selected();
        const missing = selected.find(piece => !piece.querySelector('[data-variant]').value);
        if (missing) {
          this.setStatus(this.messages.choose, true);
          const select=missing.querySelector('[data-variant]');
          select.setAttribute('aria-invalid','true');
          select.focus();
          select.reportValidity();
          return;
        }
        this.add(selected);
      }, options);
      this.querySelectorAll('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
        const img=this.querySelector('.jn-hero-image');
        img.removeAttribute('srcset');
        img.src=button.dataset.galleryImage;
        img.alt=button.dataset.galleryAlt;
        this.querySelector('.jn-photo').classList.toggle('is-product',!button.hasAttribute('data-editorial'));
        this.querySelectorAll('[data-gallery-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        this.querySelector('[data-caption]').textContent=button.hasAttribute('data-editorial')?this.editorialCaption:this.messages.original;
      }, options));
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.ready=false; }
    selected() { return this.pieces.filter(p=>p.querySelector('[data-include]').checked&&!p.querySelector('[data-include]').disabled); }
    money(value) { return new Intl.NumberFormat(this.dataset.locale||'es',{style:'currency',currency:this.dataset.currency||'EUR'}).format(value/100); }
    update() {
      let total=0;
      const selected=this.selected();
      this.pieces.forEach(piece=>{
        const select=piece.querySelector('[data-variant]');
        const variant=select.selectedOptions[0]?.value?select.selectedOptions[0]:[...select.options].find(o=>o.value&&!o.disabled);
        const price=Number(variant?.dataset.price||0);
        piece.querySelector('[data-price]').textContent=this.money(price);
        piece.dataset.excluded=String(!selected.includes(piece));
        if(selected.includes(piece))total+=price;
      });
      this.querySelector('[data-total]').textContent=this.money(total);
      this.querySelector('[data-count]').textContent=this.messages.count.replace('{count}',selected.length).replace('{total}',this.pieces.length);
      this.querySelector('[data-add-label]').textContent=!selected.length?this.messages.empty:selected.length===this.pieces.length?this.messages.all:this.messages.selected;
      this.querySelector('[data-add-selected]').disabled=this.busy||!selected.length;
      this.querySelector('[data-select-all]').disabled=this.busy||selected.length===this.pieces.filter(p=>!p.querySelector('[data-include]').disabled).length;
    }
    setStatus(message,error=false) { this.status.textContent=message;this.status.dataset.error=String(error); }
    async request(path,init={}) {
      const response=await fetch((window.Shopify?.routes?.root||'/')+path,{credentials:'same-origin',...init,signal:this.abort.signal});
      let data;try{data=await response.json();}catch{throw new Error(this.messages.error);}
      if(!response.ok)throw new Error(typeof data.description==='string'?data.description:this.messages.error);
      return data;
    }
    async syncCart() {
      const cart=await this.request('cart.js');
      document.querySelectorAll('[data-ja-cart-count]').forEach(el=>{el.textContent=cart.item_count;const a=el.closest('a');if(a)a.setAttribute('aria-label',a.textContent.trim());});
      return cart;
    }
    async add(pieces) {
      if(this.busy||!pieces.length)return;
      const items=pieces.map(piece=>({id:Number(piece.querySelector('[data-variant]').value),quantity:1}));
      if(items.some(item=>!item.id))return;
      this.busy=true;
      const controls=[...this.querySelectorAll('button,input,select')];
      const previous=controls.map(el=>el.disabled);
      controls.forEach(el=>{el.disabled=true;});
      this.setAttribute('aria-busy','true');
      this.setStatus(this.messages.adding);
      try {
        const result=await this.request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-drawer-section'],sections_url:window.location.pathname})});
        if(!Array.isArray(result.items)||result.items.length!==items.length)throw new Error(this.messages.error);
        this.setStatus(this.messages.success);
        this.querySelector('[data-cart-link]').hidden=false;
        try { const cart=await this.syncCart();document.dispatchEvent(new CustomEvent('janicca:cart-added',{detail:{cart,items:result.items,sections:result.sections}})); } catch { document.dispatchEvent(new CustomEvent('janicca:cart-added',{detail:{items:result.items,sections:result.sections}})); }
      } catch(error) {
        if(error.name!=='AbortError') {
          this.setStatus(error.message||this.messages.error,true);
          this.querySelector('[data-cart-link]').hidden=false;
          try{await this.syncCart();}catch{}
        }
      } finally {
        this.busy=false;
        this.removeAttribute('aria-busy');
        controls.forEach((el,i)=>{el.disabled=previous[i];});
        this.update();
      }
    }
  });
}

